import { ref as $, inject as q, toRefs as A, computed as o, unref as w, provide as E, resolveComponent as f, openBlock as d, createBlock as c, normalizeStyle as F, withKeys as B, withModifiers as D, withCtx as r, createVNode as I, renderSlot as g, createCommentVNode as v, createTextVNode as m, toDisplayString as x } from "vue";
/* empty css                    */
import G from "./design-system.es128.js";
import H from "./design-system.es37.js";
import J from "./design-system.es62.js";
import O from "./design-system.es94.js";
import P from "./design-system.es58.js";
import Q from "./design-system.es106.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
const U = {
  name: "DsMenuItem",
  components: {
    Box: H,
    Inline: J,
    Icon: P,
    Stack: O,
    DsText: Q
  },
  props: {
    selected: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    destructive: { type: Boolean, default: !1 },
    title: { type: String, default: null },
    subtitle: { type: String, default: null },
    description: { type: String, default: null },
    leadingIcon: { type: String, default: null },
    trailingIcon: { type: String, default: null }
  },
  emits: ["click"],
  setup(a, { slots: t, emit: i }) {
    const n = $(null), y = $(null), { dense: b, isControlled: p, close: u } = q("dsMenu", {}), {
      selected: l,
      disabled: s,
      destructive: k,
      subtitle: T,
      description: M,
      leadingIcon: K,
      trailingIcon: N
    } = A(a), _ = o(() => !!t.subtitle || !!T.value), S = o(() => !!t.description || !!M.value), V = o(() => !!t.leading || !!K.value), L = o(() => !!t.trailing || !!N.value), C = o(() => !!y.value), e = o(() => k.value ? s.value ? "destructive-disabled" : l.value && !C.value ? "destructive-selected" : "destructive" : s.value ? "disabled" : l.value && !C.value ? "selected" : "default"), Y = o(() => ({
      cursor: s.value ? "not-allowed" : "pointer",
      "--ds-menu-item-color": `var(--ds-menu-item-${e.value}-color)`,
      "--ds-menu-item-background-color": `var(--ds-menu-item-${e.value}-background-color)`,
      "--ds-menu-item-subtitle-color": `var(--ds-menu-item-${e.value}-subtitle-color, var(--ds-menu-item-${e.value}-color))`,
      "--ds-menu-item-description-color": `var(--ds-menu-item-${e.value}-description-color, var(--ds-menu-item-${e.value}-color))`,
      "--ds-menu-item-leading-color": `var(--ds-menu-item-${e.value}-leading-icon-color, var(--ds-menu-item-${e.value}-color))`,
      "--ds-menu-item-trailing-color": `var(--ds-menu-item-${e.value}-trailing-icon-color, var(--ds-menu-item-${e.value}-color))`,
      "--ds-menu-item-hover-color": `var(--ds-menu-item-${e.value}-hover-color, var(--ds-menu-item-${e.value}-color))`,
      "--ds-menu-item-hover-background-color": `var(--ds-menu-item-${e.value}-hover-background-color, var(--ds-menu-item-${e.value}-background-color))`,
      "--ds-menu-item-hover-leading-icon-color": `var(--ds-menu-item-${e.value}-hover-leading-icon-color, var(--ds-menu-item-${e.value}-leading-icon-color))`,
      "--ds-menu-item-hover-trailing-icon-color": `var(--ds-menu-item-${e.value}-hover-trailing-icon-color, var(--ds-menu-item-${e.value}-trailing-icon-color))`
    })), j = o(() => w(b) ? "spacing-050" : _.value || S.value ? "spacing-125" : "spacing-150");
    function z(h) {
      s.value || (i("click", h), w(p) || u == null || u());
    }
    function R(h) {
      y.value = h;
    }
    return E("dsCheckbox", {
      disabled: s,
      checked: l,
      error: o(() => k.value && l.value),
      registerCheckbox: R
    }), {
      el: n,
      dense: b,
      hasSubtitle: _,
      hasDescription: S,
      hasLeading: V,
      hasTrailing: L,
      styles: Y,
      paddingY: j,
      handleClick: z
    };
  }
};
function W(a, t, i, n, y, b) {
  const p = f("Icon"), u = f("Inline"), l = f("DsText"), s = f("Stack"), k = f("Box");
  return d(), c(k, {
    ref: "el",
    "padding-x": "spacing-200",
    "padding-y": n.paddingY,
    class: "ds-menu-item",
    style: F(n.styles),
    tabindex: "0",
    role: "menuitem",
    onClick: n.handleClick,
    onKeydown: [
      B(D(n.handleClick, ["prevent"]), ["enter"]),
      B(D(n.handleClick, ["prevent"]), ["space"])
    ]
  }, {
    default: r(() => [
      I(u, {
        "align-y": "center",
        fill: "",
        space: n.dense ? "spacing-200" : "spacing-250"
      }, {
        default: r(() => [
          n.hasLeading ? (d(), c(u, {
            key: 0,
            class: "ds-menu-item-leading",
            style: { "--ds-checkbox-tabindex": "-1" }
          }, {
            default: r(() => [
              g(a.$slots, "leading", {}, () => [
                i.leadingIcon ? (d(), c(p, {
                  key: 0,
                  name: i.leadingIcon
                }, null, 8, ["name"])) : v("", !0)
              ], !0)
            ]),
            _: 3
          })) : v("", !0),
          t[2] || (t[2] = m()),
          I(s, {
            fill: "",
            style: { "overflow-wrap": "anywhere" }
          }, {
            default: r(() => [
              I(l, { variant: "body" }, {
                default: r(() => [
                  g(a.$slots, "default", {}, () => [
                    m(x(i.title), 1)
                  ], !0)
                ]),
                _: 3
              }),
              t[0] || (t[0] = m()),
              n.hasSubtitle ? (d(), c(l, {
                key: 0,
                variant: "caption",
                class: "ds-menu-item-subtitle"
              }, {
                default: r(() => [
                  g(a.$slots, "subtitle", {}, () => [
                    m(x(i.subtitle), 1)
                  ], !0)
                ]),
                _: 3
              })) : v("", !0),
              t[1] || (t[1] = m()),
              n.hasDescription ? (d(), c(l, {
                key: 1,
                variant: "caption",
                class: "ds-menu-item-description"
              }, {
                default: r(() => [
                  g(a.$slots, "description", {}, () => [
                    m(x(i.description), 1)
                  ], !0)
                ]),
                _: 3
              })) : v("", !0)
            ]),
            _: 3
          }),
          t[3] || (t[3] = m()),
          n.hasTrailing ? (d(), c(u, {
            key: 1,
            class: "ds-menu-item-trailing"
          }, {
            default: r(() => [
              g(a.$slots, "trailing", {}, () => [
                i.trailingIcon ? (d(), c(p, {
                  key: 0,
                  name: i.trailingIcon
                }, null, 8, ["name"])) : v("", !0)
              ], !0)
            ]),
            _: 3
          })) : v("", !0)
        ]),
        _: 3
      }, 8, ["space"])
    ]),
    _: 3
  }, 8, ["padding-y", "style", "onClick", "onKeydown"]);
}
const de = /* @__PURE__ */ G(U, [["render", W], ["__scopeId", "data-v-867118b8"]]);
export {
  de as default
};
//# sourceMappingURL=design-system.es74.js.map
